.row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  cursor: pointer;
  min-height: 44px;
}

.row:hover,
.row[data-highlighted='true'] {
  background: var(--tuna-palette-action-hover);
}

.avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--tuna-palette-primary-light);
  color: var(--tuna-palette-primary-contrast);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex: 0 0 auto;
  text-transform: uppercase;
}

.text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 auto;
}

.name {
  font-size: 14px;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.email {
  font-size: 12px;
  line-height: 1.2;
  color: var(--tuna-palette-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
